import React from 'react';
import styles from './XRayCaptureDiagram.module.css';
import diagram from './xray-capture-diagram.png';

export const XRayCaptureDiagram = () => (
  <div className={styles.container}>
    <div className={styles.header}>
      <div className={styles.h1}>Click, Capture & Convert </div>
      <div>
        Supercharge your email
        <span className={styles.highlighted}>
          {' '}
          revenue by 7X. Restore your ad retargeting
        </span>
        <span> audiences to pre iOS 14 levels.</span>{' '}
        <span className={styles.highlighted}>Grow </span>your email list.
      </div>
    </div>
    <img src={diagram} className={styles.image} />
  </div>
);
